import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { CustomFormulaTypes } from '../../../entities';
import theme from '../../theme';
import { useColumnSelect } from '../../../hooks';
var DimensionSelect = function (_a) {
    var destination = _a.destination, dimensionName = _a.dimensionName, dimensionKey = _a.dimensionKey;
    var classes = useStyles();
    var _b = useState(''), selectValue = _b[0], setSelectValue = _b[1];
    var _c = useState(''), customFormula = _c[0], setCustomFormula = _c[1];
    var _d = useState(''), denominator = _d[0], setDenominator = _d[1];
    var _e = useState(false), showDenominator = _e[0], setShowDenominator = _e[1];
    var _f = useColumnSelect(dimensionKey), onDimensionChange = _f.onDimensionChange, onCustomFormulaChange = _f.onCustomFormulaChange;
    var SelectableColumns = destination.columns.map(function (column, i) {
        return (React.createElement(MenuItem, { key: i, value: column.key, "data-id": column.id, "data-label": column.key, "data-key": column.key, "data-chart": dimensionName, "data-denominator": column.id }, column.key));
    });
    var FormulaList = Object.values(CustomFormulaTypes).map(function (formula, i) {
        return (React.createElement(MenuItem, { key: i, value: formula.name, "data-customformula": formula.type, "data-denominator": formula.denominator }, formula.name));
    });
    return (React.createElement(Box, { className: classes.root },
        React.createElement(Box, { className: classes.dimensionLabel }, dimensionName),
        React.createElement(Box, { className: classes.selectGroup },
            React.createElement("div", { className: classes.selectLabel + " " + classes.groupItem }, "Column: "),
            React.createElement(FormControl, { variant: "outlined", className: classes.groupItem },
                React.createElement(Select, { "aria-label": dimensionKey, name: dimensionKey, value: selectValue, onChange: function (event) {
                        onDimensionChange(event, [event.currentTarget.dataset], 'select');
                        setSelectValue(event.target.value);
                    } }, SelectableColumns)),
            dimensionKey !== 'dimensions' ? (React.createElement(React.Fragment, null,
                React.createElement(FormControl, { variant: "outlined", disabled: selectValue ? false : true, classes: { root: classes.groupItem } },
                    React.createElement(InputLabel, { className: classes.outlined }, "Custom Formula"),
                    React.createElement(Select, { label: "Custom Formula", labelWidth: 50, className: classes.subSelect, inputProps: {
                            classes: {
                                icon: classes.icon,
                            },
                        }, "aria-label": selectValue, name: selectValue, value: customFormula, onChange: function (event) {
                            onCustomFormulaChange(event, 'customformula');
                            setCustomFormula(event.target.value);
                            event.target.value === 'Weighted Average' ? setShowDenominator(true) : setShowDenominator(false);
                        } }, FormulaList)),
                showDenominator === true ? (React.createElement(FormControl, { variant: "outlined", className: classes.groupItem },
                    React.createElement(InputLabel, { classes: { outlined: classes.outlined } }, "Denominator"),
                    React.createElement(Select, { label: "Denominnator", labelWidth: 50, className: classes.subSelect, "aria-label": selectValue, name: selectValue, value: denominator, onChange: function (event) {
                            onCustomFormulaChange(event, 'denominator');
                            setDenominator(event.target.value);
                        } }, SelectableColumns))) : null)) : null)));
};
var useStyles = makeStyles({
    root: {
        flex: 1,
        minWidth: 160,
        textAlign: 'center',
    },
    dimensionLabel: {
        width: '100%',
        padding: '6px 0',
        background: theme.palette.mono.light,
        boxSizing: 'border-box',
        '&.Mui-focused': {
            color: theme.palette.text.primary,
        },
    },
    selectGroup: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'baseline',
        marginTop: 12,
        marginBottom: 12,
        '& * .MuiSelect-root': {
            minWidth: 100,
            margin: 2,
            paddingTop: 4,
            paddingBottom: 4,
        },
    },
    groupItem: {
        margin: '0 6px',
    },
    selectLabel: {
        fontSize: 16,
        marginLeft: 11,
    },
    outlined: {
        transform: 'translate(14px, 6px) scale(1)',
        backgroundColor: 'white',
        '&.Mui-disabled': {
            color: theme.palette.text.disabled,
            borderColor: theme.palette.text.disabled,
        },
    },
    optionFormula: {
        margin: 'inherit',
    },
    subSelect: {
        fontSize: '0.86em',
        '&.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.text.disabled + "!important",
        },
    },
    icon: {
        '&.Mui-disabled': {
            fill: theme.palette.text.disabled,
        },
    },
});
export default DimensionSelect;
